exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.errors-list[data-v-ecac1b80] {\n  max-height: 300px;\n  overflow-y: auto;\n  /* Optional: adds a border so you can see the container limits */\n  list-style-type: none;\n}\n", ""]);

// exports
